<template>
  <div class="user-profile">
    <div class="avatar-container" @click="toggleUserMenu">
      <img src="@/assets/user_avatar.png" alt="用户头像" class="avatar" />
      <div class="user-name">{{ userDetail.name || account }}</div>
    </div>
    <div v-if="showUserMenu" class="user-menu">
      <div class="menu-item" @click="showChangePassword">
        <i class="el-icon-lock"></i>修改密码
      </div>
      <div class="menu-item" @click="showUserInfo" v-if="!isMobile">
        <i class="el-icon-user"></i>用户信息
      </div>
      <div class="menu-item" @click="logout" v-if="!isInDingTalk">
        <i class="el-icon-switch-button"></i>退出登录
      </div>
    </div>

    <!-- 用户信息详情面板 -->
    <div v-if="showUserDetail" class="user-detail-panel">
      <div class="detail-header">
        <h3>用户信息详情</h3>
        <i class="el-icon-close close-icon" @click="closeUserDetail"></i>
      </div>
      <div class="detail-content">
        <div class="info-row">
          <span class="info-label">姓名：</span>
          <span class="info-value">{{ userDetail.name || account }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">电话：</span>
          <span class="info-value">{{ userDetail.phone || "--" }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">部门：</span>
          <span class="info-value">{{ userDetail.department || "--" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { responsiveMixin } from "@/mixins/responsiveMixin";

export default {
  mixins: [responsiveMixin],
  props: {
    userDetail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showUserDetail: false,
      showUserMenu: false,
      account: "",
    };
  },
  created() {
    this.account = this.$store.getters['user/getUserName'];
  },
  methods: {
    closeUserDetail() {
      this.showUserDetail = false;
    },
    showChangePassword() {
      this.$emit("change-password");
      this.showUserMenu = false;
    },
    showUserInfo() {
      this.showUserDetail = true;
      this.showUserMenu = false;
      this.$emit("fetch-user-detail");
    },
    logout() {
      this.$emit("logout");
      this.showUserMenu = false;
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
  },
};
</script>
<style scoped>
.user-profile {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
  text-align: center;
}

.avatar-container {
  display: inline-block;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid #409eff;
}

.user-name {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.user-menu {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  z-index: 101;
}

.menu-item {
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu-item i {
  margin-right: 8px;
}

.menu-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
}

.menu-group {
  margin-bottom: 5px;
}

.menu-title {
  padding: 12px 20px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu-title:hover {
  background-color: #f5f7fa;
}

.menu-icon {
  margin-right: 10px;
  font-size: 16px;
  color: #409eff;
}

.user-detail-panel {
  position: absolute;
  top: 140px;
  left: 180px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1001;
  width: 260px;
  animation: slideInRight 0.3s ease;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  background: #fafbfc;
}

.detail-content {
  padding: 16px;
}

.info-value {
  color: #303133;
  font-weight: 400;
}

.info-row {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
}

.info-label {
  color: #606266;
  font-weight: 500;
  min-width: 50px;
}
</style>
